import React, { useRef, useState, useEffect } from "react";
import Webcam from "react-webcam";
import { Col, Grid, Row, Button } from "react-bootstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faUserPlus } from '@fortawesome/free-solid-svg-icons';

import EngagementSummary from "./components/EngagementsSummary.js";
import Header from "./components/Header.js";
import Footer from "./components/Footer.js";
import SettingsHelp from "./components/SettingsHelp.js";
import ConsentModal from "./components/ConsentModal.js";
import AddUserModal from "./components/AddUserModal.js"; // Importación añadida

import faceDetailsMapper from "./utils/faceDetailsMapper.js";
import getChartData from "./utils/getChartData.js";
import gateway from "./utils/gateway.js";

const App = () => {
  const [aggregate, setAggregate] = useState({
    angry: 0,
    calm: 0,
    happy: 0,
    sad: 0,
    surprised: 0,
  });

  const [detectedFaces, setDetectedFaces] = useState([]);
  const [detectedPeople, setDetectedPeople] = useState([]);
  // const [happyometer, setHappyometer] = useState(50);
  const [readyToStream, setReadyToStream] = useState(false);
  // const [webcamCoordinates, setWebcamCoordinates] = useState({});
  const [showMessage, setShowMessage] = useState(true);
  const [showGif, setShowGif] = useState(false);
  const [showEngagementSummary, setShowEngagementSummary] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [showResetButton, setShowResetButton] = useState(false);
  const [showAddUserButton, setShowAddUserButton] = useState(false);

  const [showAddUserModal, setShowAddUserModal] = useState(false); // Nuevo estado para el modal

  const iterating = useRef(false);
  const people = useRef([]);
  const webcam = useRef(undefined);

  const addUser = (params) => gateway.addUser(params);

  const getSnapshot = () => {
    if (webcam.current) {
      const image = webcam.current.getScreenshot();
      const b64Encoded = image.split(",")[1];

      gateway.getEngagement().then((response) => {
        const chartData = getChartData(response);

        // if (chartData.happyometer) {
        //   setHappyometer(chartData.happyometer);
        // }

        if (chartData.aggregate) {
          setAggregate(chartData.aggregate);
        }
      }).catch(error => {
        //console.error("Error fetching engagement: ", error);
        //alert("Error al obtener el engagement");
      });

      gateway.detectFaces(b64Encoded).then((response) => {
        const detectedFaces = response.FaceDetails.map((person) => {
          const result = faceDetailsMapper(person);
          gateway.postEngagement(result).then(() => {}).catch(error => {
            //console.error("Error posting engagement: ", error);
            //alert("Error al enviar el engagement");
          });
          return result;
        });
        setDetectedFaces(detectedFaces);

        if (iterating.current) {
          setTimeout(getSnapshot, 300);
        }
      }).catch(error => {
        console.error("Error detecting faces: ", error);
        alert("Error al detectar las caras");
      });

      gateway.searchFaces(b64Encoded).then((response) => {
        const detectedPeople = [];
        if (response.FaceMatches && response.FaceMatches.length > 0) {
          response.FaceMatches.forEach((match) => {
            const externalImageId = match.Face.ExternalImageId;
            detectedPeople.push(
              people.current.find((x) => x.externalImageId === externalImageId)
            );
          });
          setDetectedPeople(detectedPeople);
        } else {
          alert("Tu biometría no está registrada. Agrégala para registrarte");
          setDetectedPeople([]);
          setShowAddUserButton(true);
        }
      }).catch(error => {
        console.error("Error al buscar las caras: ", error);
        alert("Error al buscar las caras");
      });
    }
  };

  const setupWebcam = (instance) => {
    webcam.current = instance;

    const checkIfReady = () => {
      if (
        webcam.current &&
        webcam.current.state &&
        webcam.current.state.hasUserMedia
      ) {
        setReadyToStream(true);
      } else setTimeout(checkIfReady, 250);
    };

    checkIfReady();
  };

  const toggleRekognition = () => {
    setShowMessage(false);
    setShowButton(false);
    setReadyToStream(true);

    setTimeout(() => {
      setShowGif(true);
      setReadyToStream(false);

      setTimeout(() => {
        setShowGif(false);
        setShowEngagementSummary(true);
        setShowResetButton(true); // Mostrar el botón de reinicio
      }, 2000); // Duración del spinner.gif (2 segundos)

    }, 2000); // Tiempo adicional para mostrar el spinner (2 segundos)

    iterating.current = !iterating.current;

    if (iterating.current) {
      gateway.getPeople().then((response) => {
        if (!response.people || response.people.length === 0) {
          alert("Tu cara no está registrada");
          iterating.current = false; // Detener el procesamiento adicional
          setShowMessage(true); // Mostrar el mensaje original de acercarse a la cámara
          setShowButton(true); // Mostrar el botón nuevamente
        } else {
          people.current = response.people;
          getSnapshot();
        }
      }).catch(error => {
        console.error("Error fetching people: ", error);
        alert("Error al obtener la lista de personas registradas");
        setShowMessage(true); // Mostrar el mensaje original de acercarse a la cámara
        setShowButton(true); // Mostrar el botón nuevamente
        iterating.current = false; // Detener el procesamiento adicional
      });
    }
  };

  useEffect(() => {
    if (!showEngagementSummary) {
      localStorage.removeItem('showEngagementSummary');
    }
  }, [showEngagementSummary]);

  const toggleAddUserModal = () => {
    setShowAddUserModal(!showAddUserModal);
  };

  return (
    <>
      <div className="App" style={{ fontFamily: 'Arial, sans-serif', color: '#333', backgroundImage: 'url("./raffle-bg_1.png")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundColor: '#ef4b26', height: '100vh', }}>
        <Grid>
  {/* Fila con logos Escala y DANAconnect */}
  <Row className="justify-content-center">
    <Col xs="auto" className="d-flex align-items-center">
      {/* <a href="./">
        <img
          src="./logo-escala.png"
          style={{ height: '120px', margin: '40px 20px' }}
          alt="Logo Escala"
        />
      </a> */}
      <a href="./">
        <img
          src="./DANA-logo-horizontal-blanco.png"
          style={{ height: '100px', margin: '40px 20px' }}
          alt="Logo DANAconnect"
        />
      </a>
    </Col>
  </Row>

  {/* Fila con Powered by AWS */}
  {/* <Row className="justify-content-center">
    <Col xs="auto">
      <img
        src="./Powered-By_aws.png"
        style={{ height: '50px', marginBottom: '40px' }}
        alt="Powered by AWS"
      />
    </Col>
  </Row> */}
</Grid>

        <div>
        </div>
        <ConsentModal />
        <Grid>
          <SettingsHelp show={!window.rekognitionSettings} />
          <Row>
            <Col md={12} sm={12}>
              {showMessage && (
                <div style={{ position: 'relative', top: '-10px', left: '50%', transform: 'translateX(-50%)', color: '#fff', textAlign: 'center' }}>
                  <h1><b style={{ fontSize: '45px',lineHeight:'1', fontFamily: 'Arial, sans-serif' }}>Acércate a la cámara</b></h1>
                </div>
              )}
              {!showGif && !showEngagementSummary && (
                <Webcam
                  ref={setupWebcam}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{
                    width: 300,
                    height: 300,
                    facingMode: "user",
                  }}
                  style={{
                    borderRadius: "50%",
                    transformOrigin: "center",
                    padding: '40px',
                    marginTop: '40px',
                    marginLeft: '0px',
                    transform: 'scaleX(-1) translateX(50%)', //espejo de video
                    position: 'absolute',
                    top: '20px',
                    left: '50%',
                  }}
                  width="400"
                />
              )}
              {showGif && (
                <div style={{
                  textAlign: 'center', padding: '40px',
                  marginLeft: '0px',
                  position: 'absolute',
                  top: '50px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}>
                  <img src="/spinner.gif" alt="Loading animation" />
                </div>
              )}
              {showEngagementSummary && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '70vh', position: 'relative', top: '20px', left: '50%', transform: 'translateX(-50%)' }}>
                  <h1><EngagementSummary
                    detectedFaces={detectedFaces}
                    detectedPeople={detectedPeople}
                  /></h1>
                  {showResetButton && (
                    <Button
                      href="./"
                      style={{
                        marginTop: '80px',
                        padding: '10px 20px',
                        fontSize: '18px',
                        fontFamily: 'Arial, sans-serif',
                        backgroundColor: '#FFFFFF',
                        color: '#ef4b26',
                        border: 'none',
                        borderRadius: '15px'
                      }}
                    > <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '10px' }} />
                      Comenzar de nuevo
                    </Button>
                  )}
                </div>
              )}<div>
                {showAddUserButton && (
                  <div>
                    <Footer
                      addUser={addUser}
                    />
                  </div>
                )}</div>
            </Col>
          </Row>
        </Grid>
        {showButton && (
          <Header
            toggleRekognition={toggleRekognition}
            readyToStream={readyToStream}
          />
        )}

        {/* Botón verde flotante en la parte inferior izquierda para agregar biometria de usuario */}
       <Button
          onClick={toggleAddUserModal}
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            zIndex: 1000,
            backgroundColor: 'green',
            color: '#fff',
            fontSize: '18px',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
            border: 'none',
          }}
        >
          <FontAwesomeIcon icon={faUserPlus} />
        </Button>

        {/* Modal para agregar usuario */}
        {showAddUserModal && (
          <AddUserModal
            onSave={(user) => {
              addUser(user);
              toggleAddUserModal();
            }}
          />
        )}
      </div>
    </>
  );
};

export default App;
